import { defineMessages } from 'react-intl'

export default defineMessages({
  locationFindLocationPlaceholder: {
    id: 'app.location.findLocationPlaceholder',
    defaultMessage: 'Current location',
  },
  locationHeadline: {
    id: 'app.location.headline',
    defaultMessage: 'Location',
  },
  locationNotFound: {
    id: 'app.location.notFound',
    defaultMessage: 'Location not found',
  },
  locationPlaceholderAddress: {
    id: 'app.location.placeholderAddress',
    defaultMessage: 'Address',
  },
  claimsHeader: {
    id: 'app.claims.header',
    defaultMessage: 'Report a claim',
  },
  // TODO: Remove if new location single text field works out fine
  // locationPlaceholderCity: {
  //   id: 'app.location.placeholderCity',
  //   defaultMessage: 'City',
  // },
  // locationPlaceholderProvince: {
  //   id: 'app.location.placeholderProvince',
  //   defaultMessage: 'Province',
  // },
  // locationPlaceholderPostalCode: {
  //   id: 'app.location.placeholderPostalCode',
  //   defaultMessage: 'Postal Code',
  // },
  // locationPlaceholderCountry: {
  //   id: 'app.location.placeholderCountry',
  //   defaultMessage: 'Country',
  // },
  locationValidationAddress: {
    id: 'app.location.validationAddress',
    defaultMessage: 'Please enter your address!',
  },
  // TODO: Remove if new location single text field works out fine
  // locationValidationCity: {
  //   id: 'app.location.validationCity',
  //   defaultMessage: 'Please enter your city!',
  // },
  // locationValidationProvince: {
  //   id: 'app.location.validationProvince',
  //   defaultMessage: 'Please enter your province name!',
  // },
  // locationValidationPostalCode: {
  //   id: 'app.location.validationPostalCode',
  //   defaultMessage: 'Please enter your postal code!',
  // },
  // locationValidationPostalCountry: {
  //   id: 'app.location.validationCountry',
  //   defaultMessage: 'Please enter your country!',
  // },
  claimsFillOutTheForm: {
    id: 'app.claims.claimType.form',
    defaultMessage: 'Fill out the form',
  },
})
